import { CurrencyPipe } from "@angular/common";
import { Component } from '@angular/core';
import { ReplaceStrPipe } from "@shared/pipes/replace-str.pipe";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: 'app-ag-company-debt',
  standalone: true,
  imports: [
    CurrencyPipe,
    ReplaceStrPipe
  ],
  templateUrl: './ag-company-debt.component.html',
  styleUrl: './ag-company-debt.component.scss'
})
export class AgCompanyDebtComponent implements ICellRendererAngularComp {
  amountOwing: number | null | undefined;

  agInit(params: ICellRendererParams<number,number>): void {
    this.amountOwing = params.value;
  }

  refresh(params: ICellRendererParams<number,number>): boolean {
    this.amountOwing = params.value;
    return true;
  }
}
